<template>
    <section>
        <b-container fluid>
            <b-card title='Последние 14 дней наблюдались ли у Вас:'>
                <b-form>
                    <b-form-group 
                        id="radio-group-medications"
                        label="Какие лекарственные препараты Вы принимаете последние 30 дней"
                        label-for="radio-medications"
                        label-cols-sm="8"
                        label-cols-lg="8"
                        v-slot="{ aria }"
                    >
                        <b-form-radio-group
                            id="radio-medications"
                            v-model="terapy.medications"
                            :options="medicationsOptions"
                            :aria-describedby="aria"
                            name="radio-medications"
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        v-if="terapy.medications === 2"
                        id="radio-group-medications"
                        label="Перечислите препараты:"
                        label-for="radio-medications"
                        label-cols-sm="12"
                        label-cols-lg="12"
                    >
                        <b-form-textarea
                            id="textarea"
                            v-model="terapy.medicationsList"
                            placeholder="Перечислите лекарственные препараты через запятую"
                            rows="3"
                        ></b-form-textarea>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-prednisone"
                        label="Принимаете ли Вы преднизолон?"
                        label-for="radio-prednisone"
                        label-cols-sm="8"
                        label-cols-lg="8"
                        v-slot="{ aria }"
                    >
                        <b-form-radio-group
                            id="radio-prednisone"
                            v-model="terapy.prednisone"
                            :options="yesNoOptions"
                            :aria-describedby="aria"
                            name="radio-prednisone"
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-antineoplastic"
                        label="Принимаете ли Вы противоопухолевые препараты?"
                        label-for="radio-antineoplastic"
                        label-cols-sm="8"
                        label-cols-lg="8"
                        v-slot="{ aria }"
                    >
                        <b-form-radio-group
                            id="radio-antineoplastic"
                            v-model="terapy.antineoplastic"
                            :options="yesNoOptions"
                            :aria-describedby="aria"
                            name="radio-antineoplastic"
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-radiationTherapy"
                        label="Проводилась ли Вам лучевая терапия в течение последнего года?"
                        label-for="radio-radiationTherapy"
                        label-cols-sm="8"
                        label-cols-lg="8"
                        v-slot="{ aria }"
                    >
                        <b-form-radio-group
                            id="radio-radiationTherapy"
                            v-model="terapy.radiationTherapy"
                            :options="yesNoOptions"
                            :aria-describedby="aria"
                            name="radio-radiationTherapy"
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        id="radio-group-adverseReactions"
                        label="Была ли у Вас побочные реакции на вакцинацию в прошлом?"
                        label-for="radio-adverseReactions"
                        label-cols-sm="8"
                        label-cols-lg="8"
                        v-slot="{ aria }"
                    >
                        <b-form-radio-group
                            id="radio-adverseReactions"
                            v-model="terapy.adverseReactions"
                            :options="yesNoOptions"
                            :aria-describedby="aria"
                            name="radio-adverseReactions"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-form>
            </b-card>
        </b-container>
    </section>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex"

export default {
    name: "medications",
    data() {
        return {
            yesNoOptions: [
                { text: "Нет", value: 1 },
                { text: "Да", value: 2 },
            ],
            medicationsOptions: [
                { text: "Нет", value: 1 },
                { text: "Опишите какие", value: 2 },
            ],
            terapy: {
                medications: "",
                medicationsList: "",
                prednisone: "",
                antineoplastic: "",
                radiationTherapy: "",
                adverseReactions: "",
            },
            answers: [],
        }
    },
    methods: {
        ...mapActions('interview', ['sendUserAnswers']),


        concatAnswers() {
            let cnt = 20;
            for (let [key, value] of Object.entries(this.terapy)) {
                if (typeof value === "number") {
                    let obj = {
                        id_question: cnt + 1,
                        int_answer: value,
                        text_answer: ""
                    }
                    this.answers.push(obj);
                    cnt += 1;
                } else {
                    if (value !== null) {
                        let obj = {
                            id_question: cnt + 1,
                            int_answer: 0,
                            text_answer: value
                        }
                        this.answers.push(obj);
                        cnt += 1;
                    }
                }
            }
            this.sendUserAnswers(this.answers);
        }
    },

}
</script>


// WEBPACK FOOTER //
// src/components/interview-components/Medications.vue